export const processTemplateVariables = (obj, variables) => {
  if (typeof obj === "string") {
    return Object.entries(variables).reduce((s, [k, v]) => s.replaceAll(`{{${k}}}`, v || ""), obj);
  }
  if (Array.isArray(obj)) return obj.map((o) => processTemplateVariables(o, variables));
  if (obj && typeof obj === "object") {
    return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, processTemplateVariables(v, variables)]));
  }
  return obj;
};
